// extracted by mini-css-extract-plugin
module.exports = {"list":"styles_list__1kY0L","item":"styles_item__2r2kz","placeCount":"styles_placeCount__3m1hB"};